// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"99b11fa5","688":"43b1f1c3","856":"030623be","952":"b17c135c","960":"edeb0d27"}[chunkId] + ".chunk.js";
};